import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getWarehouseAllocations = (warehouse, urlParameters = {}) => apiActionCreator({
  'endpoint': `/warehouses/${warehouse}/allocations${getUrlParameters(urlParameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_WAREHOUSE_ALLOCATIONS,
    ActionTypes.GOTTEN_WAREHOUSE_ALLOCATIONS,
    [
      ActionTypes.GOTTEN_WAREHOUSE_ALLOCATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadWarehouseAllocations = (warehouse, urlParameters = {}) => apiActionCreator({
  'endpoint': `/warehouses/${warehouse}/allocations/excel${getUrlParameters(urlParameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_WAREHOUSE_ALLOCATIONS,
    ActionTypes.DOWNLOADED_WAREHOUSE_ALLOCATIONS,
    [
      ActionTypes.DOWNLOADED_WAREHOUSE_ALLOCATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const resetWarehouseAllocations = () => ({
  'type': ActionTypes.RESET_WAREHOUSE_ALLOCATIONS,
});

export const changeWarehouseAllocationPage = (newPage) => ({
  'type': ActionTypes.CHANGE_WAREHOUSE_ALLOCATIONS_PAGE,
  'payload': newPage,
});

export const changeWarehouseAllocationPageSize = (pageSize) => ({
  'type': ActionTypes.CHANGE_WAREHOUSE_ALLOCATIONS_PAGE_SIZE,
  'payload': pageSize,
});

export const clearSelectedLocations = () => ({
  'type': ActionTypes.CLEAR_SELECTED_LOCATIONS,
});

export const updateSelectedLocations = (location) => ({
  'type': ActionTypes.UPDATE_SELECTED_LOCATIONS,
  'payload': location,
});
